// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legend-panel[data-v-dbd2c68a]{height:100%}", ""]);
// Exports
module.exports = exports;
